import React from 'react';
import IconFavouriteSelected from './IconFavouriteSelected';
import IconFavouriteUnselected from './IconFavouriteUnselected';
import PropTypes from 'prop-types';

const IconFavourite = ({ value = false, size = 50, ...props }) => {
    return value ? (
        <IconFavouriteSelected size={size} {...props} />
    ) : (
        <IconFavouriteUnselected size={size} {...props} />
    );
};

IconFavourite.defaultProps = {
    value: false,
    disabled: false,
    size: 50
};

IconFavourite.propTypes = {
    value: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    size: PropTypes.any,
    style: PropTypes.object,
    fill: PropTypes.any
};

export default IconFavourite;
